import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/pro-thin-svg-icons';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Rating,
    TextField,
    useTheme,
} from '@mui/material';
import { FontIcon } from '@resurs-internal/mui';
import { useState } from 'react';

import bannerOne from '../../assets/jpg/bannerOne.jpg';
import { config } from '../../helpers/apiConfig';
import { useAppSelector } from '../../hooks';
import useSettings from '../../hooks/useSettings';
import { selectFieldValue } from '../../store/applicationform/applicationFormSelectors';
import { AuthenticationData } from '../../store/authentication';
import Button from '../Button/Button';
import CheckboxField from '../CheckboxField/CheckboxField';
import Subtitle from '../Subtitle/Subtitle';
import {
    ActionStyles,
    ContentStyles,
    HeaderStyles,
    RatingStyles,
    SubtitleWrapper,
    SurveyModalStyles,
    TextFieldStyles,
} from './SurveyModal.styles';

type Props = {
    label: string;
    dialogTitle: string;
    dialogSubtitle: string;
    dialogPlaceholder: string;
    dialogCheckboxLabel: string;
    dialogButton: string;
};

//TODO: replace with real service and move to seperate file
export const testService = async (
    apiKey: string,
    rating: number | null,
    _surveyModalAgreeToggle: boolean,
    _feedback: string,
    authenticationData?: AuthenticationData,
): Promise<any> => {
    //TODO: add type
    const url = `${bannerOne}?rating=${rating}`;

    const request = {
        method: 'GET',
        headers: config(apiKey, authenticationData),
    };
    try {
        const response = await fetch(url, request);
        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }
        await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const SurveyModal = ({
    label,
    dialogTitle,
    dialogSubtitle,
    dialogPlaceholder,
    dialogCheckboxLabel,
    dialogButton,
}: Props) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [rating, setRating] = useState<number | null>(null);
    const [feedback, setFeedback] = useState<string>('');
    const { apiKey } = useSettings();

    const surveyModalAgreeToggle = useAppSelector(selectFieldValue)('surveyModalAgreeToggle') === 'true';

    const sendSurvey = async () => {
        await testService(apiKey, rating, surveyModalAgreeToggle, feedback);
        console.log('send rating: ', rating);
    };

    return (
        <SurveyModalStyles>
            <SubtitleWrapper>
                <Subtitle text={label} />
                <Rating
                    value={rating}
                    onChange={(_, newValue) => setRating(newValue)}
                    size="large"
                    onClick={() => setOpen(true)}
                />
            </SubtitleWrapper>
            <Dialog open={open} onClose={() => setOpen(false)} aria-modal="true">
                <HeaderStyles>
                    <DialogTitle id="survey-dialog-title" color={'grey.900'}>
                        {dialogTitle}
                    </DialogTitle>
                    <IconButton aria-label="close dialog" onClick={() => setOpen(false)}>
                        <FontIcon
                            icon={faXmark as IconDefinition}
                            type={'outline'}
                            size="md"
                            color={theme.palette.grey[900]}
                        />
                    </IconButton>
                </HeaderStyles>
                <DialogContent dividers sx={ContentStyles} id="survey-dialog-content">
                    <RatingStyles>
                        <Rating
                            value={rating}
                            onChange={(_, newValue) => setRating(newValue)}
                            size="large"
                            sx={{
                                '& .MuiRating-label:last-of-type': { display: 'none' },
                            }}
                        />
                    </RatingStyles>
                    <Subtitle text={dialogSubtitle} />
                    <TextField
                        sx={TextFieldStyles}
                        type="text"
                        multiline
                        rows={4}
                        value={feedback}
                        onChange={(event) => setFeedback(event.target.value)}
                        label={dialogPlaceholder}
                    />
                    <CheckboxField name="surveyModalAgreeToggle" label={dialogCheckboxLabel} />
                    <DialogActions sx={ActionStyles}>
                        <Button
                            fill={true}
                            onClick={() => {
                                sendSurvey();
                                setOpen(false);
                            }}>
                            {dialogButton}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </SurveyModalStyles>
    );
};

export default SurveyModal;
